import {
    RECEIVE_CONTRACT_DISPATCHES,
    REQUEST_CONTRACT_DISPATCHES,
    UPDATE_CONTRACT_DISPATCHES,
    ERROR_CONTRACT_DISPATCHES,
    RELOAD_CONTRACT_DISPATCHES
} from '../types'
import {initialFetchState} from '../../constants/defaultValues'
import {loadDataRefresh} from "../../constants/constants"

export default (state = initialFetchState, action = {}) => {
    switch(action.type) {
        case REQUEST_CONTRACT_DISPATCHES:
            return {
                ...state,
                isFetching: true,
                message: '',
                errors: {}
            }
        case RECEIVE_CONTRACT_DISPATCHES:
            return {
                ...state,
                isFetching: false,
                data: action.payload,
                shouldReload: false,
                validUntil: loadDataRefresh.default + Date.now(),
                message: '',
            }
        case RELOAD_CONTRACT_DISPATCHES:
            return {
                ...state,
                shouldReload: true
            }
        case UPDATE_CONTRACT_DISPATCHES:
            const data = state.data
            let index = null
            if(data.results){
                if(action.updateType == "delete"){
                    index = data.results.findIndex(item => item.id == action.id)
                    data.results.splice(index, 1)
                }else{
                    index = data.results.findIndex(item => item.id == action.id)
                    if(index > -1){
                        data.results[index] = action.payload
                    }else{
                        data.results.unshift(action.payload)
                    }
                }
            }
            return {
                ...state,
                isFetching: false,
                data,
                errors: action.errors
            }
        case ERROR_CONTRACT_DISPATCHES:
            return {
                ...state,
                isFetching: false,
                errors: action.errors,
                message: action.errors.server || '',
            }
        default:
            return state
    }
}